import { getFormValues, reset } from 'redux-form'
import { RUTA_USUARIO } from '../../../config/ruta_usuario'
import User from '../../../models/user'
import { openDialogSession } from '../../session/actions'
import { setShowFooter } from '../../Utils/actions'
import { FORM_SOLICITUD_ACCESO, FORM_PERFIL } from '../../../config/forms'
import CorreoCargador from '../../../models/correoElectronico/correoCargador'
import CorreoCorredor from '../../../models/correoElectronico/correoCorredor'
import Cargador from '../../../models/cargador/cargador'
import Corredor from '../../../models/corredor/corredor'
import { toast } from 'react-toastify'
import moment from 'moment'
import Swal from 'sweetalert2'

export function checkUserStatus (history) {
  return (dispatch) => {
    dispatch({ type: 'START_CHECK_SESSION' })
    User.getStatus()
      .then((result) => {
        const {
          authenticated,
          user,
          roles,
          message
        } = result
        dispatch({
          type: 'END_CHECK_SESSION',
          authenticated,
          user,
          roles,
          message
        })
        const infoToken = JSON.parse(localStorage.getItem('jwTokenIntrospect'))
        // console.log('token', infoToken)
        // console.log('Su token vence: ', moment.unix(infoToken.exp).format('DD/MM/YYYY HH:mm:ss'))
        const interval = setInterval(() => {
          if (RUTA_USUARIO[user]) {
            // usuario en autologin
            console.log('Token vencido', RUTA_USUARIO[user])
            history.push('/laridae/login')
            window.location.reload()
          } else {
            dispatch(openDialogSession())
            clearInterval(interval)
          }
        }, ((infoToken.exp - 5) - infoToken.iat) * 1000)
      })
      .catch((err) => err)
  }
}

// Si el usuario tiene el autologin declarado en las constantes de RUTA_USUARIO
// y sus datos de acceso estan guardados en el navegador, cuando se vence el token
// va a volver a loguearse solo.
export function autoLogin (history) {
  return (dispatch) => {
    if (navigator.credentials) {
      navigator.credentials.get({
        password: true
      }).then((cred) => {
        if (cred) {
          // console.log('es autologin?', RUTA_USUARIO[cred.id])
          if ((cred.type === 'password') && RUTA_USUARIO[cred.id]) {
            if (RUTA_USUARIO[cred.id].autoLogin) {
              const options = {
                history: history,
                redirectTo: RUTA_USUARIO[cred.id].redirectTo
              }
              dispatch(loginUser(cred.id, cred.password, options))
            }
          }
        }
      })
    }
  }
}

export function loginUser (username, password, options = {}) {
  const {
    history,
    redirectTo
  } = options
  return (dispatch) => {
    dispatch({
      type: 'VALIDATING_USER'
    })
    User.login(username, password)
      .then((result) => {
        const {
          authenticated,
          user,
          roles,
          message
        } = result
        if (authenticated) {
          dispatch({
            type: 'VALIDATED_USER',
            user,
            roles
          })
          history.push(redirectTo)
          window.location.reload()
        } else {
          dispatch({
            type: 'INVALID_USER',
            message
          })
        }
      })
  }
}

export function logoutUser (history) {
  return (dispatch) => {
    dispatch({
      type: 'TRY_LOGOUT_USER'
    })
    User.logout()
      .then((result) => {
        dispatch({ type: 'USER_LOGGED_OUT' })
        // history.push('/login')
      })
  }
}

export function sendMail (name, email, message, options = {}) {
  // const {
  // history,
  // redirectTo
  // } = options
  return (dispatch) => {
    dispatch({
      type: 'START_SENDING_EMAIL'
    })
    // mailto

    dispatch({
      type: 'END_SENDING_EMAIL'
    })
  }
}

export function setShowFooterLogin (show) {
  return (dispatch) => {
    dispatch(setShowFooter(show))
  }
}

export function submitSolicitudAcceso () {
  return (getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_SOLICITUD_ACCESO)(state)
    console.log('formValues --> ', formValues)
  }
}

// Funciones utilizadas para editar el perfil de usuario
export function buscarCorreoCargador (username, formChange) {
  return dispatch => {
    // Obtener el cuit del cargador a partir del username
    Cargador.getCuitMapeoByUsername(username)
      .then(mapeo => {
        // Con el cuit obtener el correo del cargador
        dispatch({ type: 'REQUEST_CONSULTA_CORREO_CARGADOR' })
        CorreoCargador.getCorreoCargador(mapeo.cargador)
          .then(data => {
            dispatch({ type: 'RECEIVE_CONSULTA_CORREO_CARGADOR', data })
            formChange('emailNotificaciones', data.correoElectronico)
            formChange('nombre', data.nombre)
          })
          .catch(error => {
            console.log(error)
            toast.error('Error al consultar el correo')
          })
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al consultar mapeo cargador')
      })
  }
}

export function buscarCorreoCorredor (username, formChange) {
  return dispatch => {
    // Obtener el cuit del corredor a partir del username
    Corredor.getCuitMapeoByUsername(username)
      .then(mapeo => {
        // Con el cuit obtener el correo del corredor
        dispatch({ type: 'REQUEST_CONSULTA_CORREO_CORREDOR' })
        CorreoCorredor.getCorreoCorredor(mapeo.corredor)
          .then(data => {
            dispatch({ type: 'RECEIVE_CONSULTA_CORREO_CORREDOR', data })
            formChange('emailNotificaciones', data.correoElectronico)
            formChange('nombre', data.nombre)
          })
          .catch(error => {
            console.log(error)
            toast.error('Error al consultar el correo')
          })
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al consultar mapeo corredor')
      })
  }
}

export function isPerfilComplete () {
  return (dispatch, getState) => {
    const state = getState()
    const { username } = state.auth
    User.getInfoUsername(username)
      .then(data => {
        dispatch({ type: 'RECEIVE_CONSULTA_INFO_USER', data })
        const isComplete = data.mail !== null && data.telefono !== null
        const ultimoAcceso = moment(data.oldLastAccess).date()
        const diaDeHoy = moment().date()
        if (diaDeHoy !== ultimoAcceso) {
          if (!isComplete) {
            Swal.fire({
              icon: 'warning',
              title: 'Atención...',
              text: 'Su perfil no está completo. Por favor, actualice su información de contacto.',
              confirmButtonText: 'Entendido',
              showCloseButton: true,
              footer: ''
            })
          } else {
            dispatch(isPerfilNotificacionesComplete())
          }
        }
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al consultar la información del Usuario')
      })
  }
}

export function isPerfilNotificacionesComplete () {
  return (dispatch, getState) => {
    const state = getState()
    const { username, roles } = state.auth
    const rolDeCupo = roles.filter((r) => r === 'CARGADOR' || r === 'CORREDOR')
    if (rolDeCupo.length > 0) {
      if (rolDeCupo[0] === 'CARGADOR') {
        // Obtener el cuit del cargador a partir del username
        Cargador.getCuitMapeoByUsername(username)
          .then(mapeo => {
            // Con el cuit obtener el correo del cargador
            CorreoCargador.getCorreoCargador(mapeo.cargador)
              .then(data => {
                const isComplete = data && data.correoElectronico !== null && data.nombre !== null
                if (!isComplete || data === null) {
                  Swal.fire({
                    icon: 'warning',
                    title: 'Atención...',
                    text: `Su perfil como Cargador no está completo. Por favor, complete su correo de Notificaciones para recibir las nominaciones de cupos.`,
                    confirmButtonText: 'Entendido',
                    showCloseButton: true,
                    footer: ''
                  })
                }
              })
          })
      } else if (rolDeCupo[0] === 'CORREDOR') {
        // Obtener el cuit del corredor a partir del username
        Corredor.getCuitMapeoByUsername(username)
          .then(mapeo => {
          // Con el cuit obtener el correo del cargador
            CorreoCorredor.getCorreoCorredor(mapeo.corredor)
              .then(data => {
                const isComplete = data && data.correoElectronico !== null && data.nombre !== null
                if (!isComplete || data === null) {
                  Swal.fire({
                    icon: 'warning',
                    title: 'Atención...',
                    text: `Su perfil como Corredor no está completo. Por favor, complete su correo de Notificaciones para recibir las nominaciones de cupos.`,
                    confirmButtonText: 'Entendido',
                    showCloseButton: true,
                    footer: ''
                  })
                }
              })
          })
      }
    }
  }
}

export function buscarInfoUser (username, formChange) {
  return dispatch => {
    // Obtener info del username
    User.getInfoUsername(username)
      .then(data => {
        dispatch({ type: 'RECEIVE_CONSULTA_INFO_USER', data })
        formChange('email', data.mail)
        formChange('telefono', data.telefono)
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al consultar la información del Usuario')
      })
  }
}

export function submitUpdatePerfil (username, rolDeCupo) {
  return (dispatch, getState) => {
    // Actualizar perfil del usuario
    const state = getState()
    const formValues = getFormValues(FORM_PERFIL)(state)
    console.log('valores form', formValues)

    if ((formValues.emailNotificaciones === undefined && formValues.nombre !== undefined) ||
      (formValues.emailNotificaciones !== undefined && formValues.nombre === undefined)) {
      Swal.fire({
        showCloseButton: true,
        icon: 'error',
        title: 'Atención...',
        text: 'Debe completar ambos campos de notificación de cupo, o dejar ambos vacíos',
        confirmButtonText: 'Aceptar',
        footer: ''
      })
      return
    }

    User.updateInfoUsername(username, formValues.email, (formValues.telefono !== undefined) ? formValues.telefono : null)
      .then(data => {
        dispatch({ type: 'UPDATE_INFO_USER', data })
        if (!rolDeCupo.length > 0) {
          Swal.fire({
            icon: 'success',
            title: 'Atención...',
            text: 'Se actualizaron sus datos de perfil correctamente',
            showConfirmButton: false,
            confirmButtonText: 'Cerrar',
            timer: 2000,
            footer: ''
          })
        }
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al actualizar la información del Usuario')
      })
    if (rolDeCupo.length > 0) {
      if (rolDeCupo[0] === 'CARGADOR') {
        console.log('Redirigiendo a cargador...')
        // Obtener el cuit del cargador a partir del username
        Cargador.getCuitMapeoByUsername(username)
          .then(mapeo => {
            // Con el cuit obtener el correo del cargador
            CorreoCargador.getCorreoCargador(mapeo.cargador)
              .then(data => {
                if (data && data.correoElectronico !== null && formValues.emailNotificaciones) {
                  // Existe el correo y se modifica
                  CorreoCargador.actualizarCorreoCargador(data.id, formValues.nombre, formValues.emailNotificaciones, mapeo.cargador)
                    .then((data) => {
                      console.log('Correo cargador actualizado', data)
                      if (data.error === false) {
                        Swal.fire({
                          icon: 'success',
                          title: 'Atención...',
                          text: 'Se modificaron sus datos de notificación correctamente',
                          showConfirmButton: false,
                          timer: 2000
                        })
                      }
                    })
                } else if (data && data.correoElectronico !== null && !formValues.emailNotificaciones) {
                  // Existe el correo y se borra
                  Swal.fire({
                    title: '¿Confirma la operación?',
                    text: 'Se eliminará el correo de notificaciones de cupo',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Aceptar'
                  }).then((result) => {
                    if (result.isConfirmed) {
                      CorreoCargador.eliminarCorreoCargador(data.id)
                        .then((data) => {
                          console.log('Borrando correo cargador...', data)
                          if (data.error === false) {
                            dispatch(reset('FORM_PERFIL'))
                            Swal.fire({
                              title: 'Eliminado!',
                              text: 'No recibirá notificaciones.',
                              icon: 'success'
                            })
                          }
                        })
                    }
                  })
                } else if ((!data || data.correoElectronico === null) && formValues.emailNotificaciones) {
                  // No existe el correo y se crea
                  CorreoCargador.agregarCorreoCargador(formValues.nombre, formValues.emailNotificaciones, mapeo.cargador)
                    .then((data) => {
                      if (data.error === false) {
                        console.log('Correo cargador agregado', data)
                        Swal.fire({
                          icon: 'success',
                          title: 'Atención...',
                          text: 'Se modificaron sus datos de notificación correctamente',
                          showConfirmButton: false,
                          timer: 2000
                        })
                      }
                    })
                }
              })
              .catch(error => {
                console.log(error)
                toast.error('Error al consultar el correo')
              })
          })
      } else if (rolDeCupo[0] === 'CORREDOR') {
        console.log('Redirigiendo a corredor...')
        // Obtener el cuit del corredor a partir del username
        Corredor.getCuitMapeoByUsername(username)
          .then(mapeo => {
          // Con el cuit obtener el correo del cargador
            CorreoCorredor.getCorreoCorredor(mapeo.corredor)
              .then(data => {
                if (data && data.correoElectronico !== null && formValues.emailNotificaciones) {
                // Existe el correo y se modifica
                  CorreoCorredor.actualizarCorreoCorredor(data.id, formValues.nombre, formValues.emailNotificaciones, mapeo.corredor)
                    .then((data) => {
                      console.log('Correo corredor actualizado', data)
                      if (data.error === false) {
                        Swal.fire({
                          icon: 'success',
                          title: 'Atención...',
                          text: 'Se modificaron sus datos de notificación correctamente',
                          showConfirmButton: false,
                          timer: 2000
                        })
                      }
                    })
                } else if (data && data.correoElectronico !== null && !formValues.emailNotificaciones) {
                // Existe el correo y se borra
                  Swal.fire({
                    title: '¿Confirma la operación?',
                    text: 'Se eliminará el correo de notificaciones de cupo',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Aceptar'
                  }).then((result) => {
                    if (result.isConfirmed) {
                      CorreoCorredor.eliminarCorreoCorredor(data.id)
                        .then((data) => {
                          console.log('Borrando correo corredor...', data)
                          if (data.error === false) {
                            dispatch(reset('FORM_PERFIL'))
                            Swal.fire({
                              title: 'Eliminado!',
                              text: 'No recibirá notificaciones.',
                              icon: 'success'
                            })
                          }
                        })
                    }
                  })
                } else if ((!data || data.correoElectronico === null) && formValues.emailNotificaciones) {
                // No existe el correo y se crea
                  CorreoCorredor.agregarCorreoCorredor(formValues.nombre, formValues.emailNotificaciones, mapeo.corredor)
                    .then((data) => {
                      if (data.error === false) {
                        console.log('Correo corredor agregado', data)
                        Swal.fire({
                          icon: 'success',
                          title: 'Atención...',
                          text: 'Se modificaron sus datos de notificación correctamente',
                          showConfirmButton: false,
                          timer: 2000
                        })
                      }
                    })
                }
              })
              .catch(error => {
                console.log(error)
                toast.error('Error al consultar el correo')
              })
          })
      }
    }
  }
}
